import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from './pages/pages.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: PagesComponent, children: [
      { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
      { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
      { path: 'collectionView', loadChildren: () => import('./pages/documents/collection-view/collection-view.module').then(m => m.CollectionViewModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'spreadsheetCreation', loadChildren: () => import('./pages/documents/spreadsheet-creation/spreadsheet-creation.module').then(m => m.SpreadsheetCreationModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'spreadsheetDetail', loadChildren: () => import('./pages/documents/spreadsheet-detail/spreadsheet-detail.module').then(m => m.SpreadsheetDetailModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'users', loadChildren: () => import('./pages/settings/users/users.module').then(m => m.UsersModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'rolePerm', loadChildren: () => import('./pages/settings/role-perm/role-perm.module').then(m => m.RolePermModule), canActivate: [AuthGuard, PermissionGuard] },
    ]
  },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
  { path: '**', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
